import { Toast } from "primereact/toast";
import { FC, ReactNode, createContext, useContext, useRef } from "react";

const ToastContext = createContext({
    msgSucesso: (title: string, text: string) => { },
    msgErro: (title: string, text: string) => { },
    msgInfo: (title: string, text: string) => { },
    msgAlerta: (title: string, text: string) => { },
});

export const ToastProvider: FC<{ children: ReactNode }> = ({ children }) => {

    const toastRef = useRef<Toast>(null);

    const msg = (type: 'success' | 'info' | 'warn' | 'error' | undefined, title: string, text: string) => {
        if (!toastRef.current) {
            return;
        }
        toastRef.current?.show({ severity: type, summary: title, detail: text, life: 3000 });
    };

    const msgSucesso = (title: string, text: string) => {
        msg('success', title, text);
    };

    const msgErro = (title: string, text: string) => {
        msg('error', title, text);
    };

    const msgInfo = (title: string, text: string) => {
        msg('info', title, text);
    };

    const msgAlerta = (title: string, text: string) => {
        msg('warn', title, text);
    };

    return (
        <ToastContext.Provider value={{ msgSucesso, msgErro, msgInfo, msgAlerta }}>
            <Toast ref={toastRef} />
            <div>{children}</div>
        </ToastContext.Provider>
    );
};

export const useToastContext = () => {
    const context = useContext(ToastContext);

    if (!context) {
        throw new Error(
            "useToastContext have to be used within ToastContextProvider"
        );
    }

    return context;
};
